// @ts-nocheck - Class component types incompatible with React 18 + TS5
import React from 'react';
import { Helmet as RHelmet } from 'react-helmet';

interface OwnProps {
  title?: string;
  enableRobots?: boolean;
}

const Helmet = (props: OwnProps) => {
  const title = props.title ? `${props.title} - mWork365` : 'mWork365';

  return (
    <RHelmet>
      <title>{title}</title>
      {props.enableRobots ? (
        <meta name="robots" content="index, follow" />
      ) : (
        <meta name="robots" content="noindex, nofollow" />
      )}
    </RHelmet>
  );
};

export default Helmet;
